import { lazy } from 'react';
import { createBrowserRouter, Navigate, useLocation } from 'react-router-dom';

import Layout from '../pages/components/Layout';

// Lazy load components for code splitting
const MenuManager = lazy(() => import('../pages/MenuManager/index'));
const NotFound = lazy(() => import('../pages/NotFound'));
const PageManager = lazy(() => import('../pages/PageManager/index'));
const ViewManager = lazy(() => import('../pages/ViewManager/index'));
const RootRedirect = () => {
  const { search } = useLocation();
  return <Navigate to={`menu-manager${search}`} replace />;
};

const routes = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <RootRedirect />,
      },
      {
        path: 'menu-manager',
        element: <MenuManager />,
        label: 'Menu Manager',
      },
      {
        path: 'page-manager',
        element: <PageManager />,
        label: 'Page Manager',
      },
      {
        path: 'view-manager',
        element: <ViewManager />,
        label: 'View Manager',
      },
      {
        path: "*",
        element: <NotFound />,
        label: 'Not Found',
      },
    ],
  },
];

const router = createBrowserRouter(routes);
export default router;